import HealthIcon from '@/shared/ui/Icon/svg/HealthIcon.vue'
import ManaIcon from '@/shared/ui/Icon/svg/ManaIcon.vue'
import PotionIcon from '@/shared/ui/Icon/svg/PotionIcon.vue'
import MindIcon from '@/shared/ui/Icon/svg/MindIcon.vue'
import AcceptIcon from '@/shared/ui/Icon/svg/AcceptIcon.vue'
import CancelIcon from '@/shared/ui/Icon/svg/CancelIcon.vue'
import PlusIcon from '@/shared/ui/Icon/svg/PlusIcon.vue'
import EditIcon from '@/shared/ui/Icon/svg/EditIcon.vue'
import ArrowIcon from '@/shared/ui/Icon/svg/ArrowIcon.vue'
import Heal from '@/shared/ui/Icon/svg/Heal.vue'
import Damage from '@/shared/ui/Icon/svg/Damage.vue'
import Luck from '@/shared/ui/Icon/svg/Luck.vue'
import Save from '@/shared/ui/Icon/svg/Save.vue'
import Load from '@/shared/ui/Icon/svg/Load.vue'
import Restore from '@/shared/ui/Icon/svg/Restore.vue'
import Dices from '@/shared/ui/Icon/svg/Dices.vue'
import DiceNeutral from '@/shared/ui/Icon/svg/DiceNeutral.vue'
import DiceNegative from '@/shared/ui/Icon/svg/DiceNegative.vue'
import DicePositive from '@/shared/ui/Icon/svg/DicePositive.vue'
import LuckyDiceNeutral from '@/shared/ui/Icon/svg/LuckyDiceNeutral.vue'
import LuckyDicePositive from '@/shared/ui/Icon/svg/LuckyDicePositive.vue'
import List from '@/shared/ui/Icon/svg/List.vue'
import Characters from '@/shared/ui/Icon/svg/Characters.vue'
import Caret from '@/shared/ui/Icon/svg/Caret.vue'

export default {
	ArrowIcon,
	Dices,
	Caret,
	DiceNegative,
	DiceNeutral,
	DicePositive,
	LuckyDicePositive,
	LuckyDiceNeutral,
	Characters,
	Load,
	Save,
	Luck,
	Restore,
	HealthIcon,
	ManaIcon,
	PotionIcon,
	MindIcon,
	EditIcon,
	Heal,
	Damage,
	PlusIcon,
	CancelIcon,
	AcceptIcon,
	List
}
